import React, { Component } from 'react';
import DashDialog from 'screens/components/basic/DialogHeaderDashboard'
import CannaCollectiveImg from 'images/CannaCollectiveLogo.png';

class CustomerCare extends Component {
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div id="chart11" className="customerCareBg sm-item">
                <DashDialog text="Independent Retail Solution" nolink />
                <div className='position-relative pb-5'>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12 border-right'>
                                <h5 className='purpleText m-0 mb-2 bold'>Canna Collective</h5>
                                <div className="d-flex">
                                    <div>
                                        <ul className="ml--12px">
                                            <li className="grayText text-left">Start Monetizing your data with Canna Collective</li>
                                            <li className="grayText text-left">Unlock untapped revenue streams within your business</li>
                                            <li className="grayText text-left">Level the playing field with Corporate Stores</li>
                                            <li className="grayText text-left">No Monthly Fee</li>
                                            <li className="grayText text-left">Third party discounts on insurance and accessories</li>
                                            <li className="grayText text-left">Earn up to $5,000 per month!</li>
                                        </ul>
                                    </div>
                                    <div><img src={CannaCollectiveImg} className="posCannaCollectiveImg"/></div>
                                </div>
                            </div>
                        </div>
                        <div className='d-flx justify-content-around mt-1 row'>
                            <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
                                <div className='solutionsandResourcesBg'>
                                    <a href="https://cannacollective.ca/" className='txtWhiteFontLink' target="_blank">LEARN MORE</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CustomerCare;
